import * as React from 'react'
import type { ReactNode } from 'react'
import clsx from 'clsx'
import './Pill.css'

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'accent'

interface Props {
  variant?: Variant
  children: ReactNode
  className?: string
}

export function Pill({ variant = 'neutral', children, className }: Props): React.JSX.Element {
  return <span className={clsx('pill', `pill-${variant}`, className)}>{children}</span>
}
